// Podium past talks: review, export or delete talks saved on this device.

import { icons } from '../shared/icons.js';

const esc = (value) => window.podium.escapeHtml(value);

function sortedSessions() {
    return window.podium.getSavedSessions()
        .slice()
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
}

function sessionLanguages(session) {
    if (Array.isArray(session.languages) && session.languages.length) return session.languages;
    const seen = new Set();
    (session.messages || []).forEach((m) => Object.keys(m.translations || {}).forEach((k) => seen.add(k)));
    // Speaker language first, then the rest in the usual order.
    const order = window.PODIUM_LANGUAGES.map((l) => l.code);
    return [...seen].sort((a, b) => (a === session.speakerLanguage ? -1 : b === session.speakerLanguage ? 1 : order.indexOf(a) - order.indexOf(b)));
}

function initpastsessions() {
    const page = document.getElementById('page-past-sessions');
    const sessions = sortedSessions();

    page.innerHTML = `
        <div class="pd-page">
            <header class="pg-header pg-header--bar">
                <button type="button" class="pg-iconbtn" id="past-back-button" aria-label="Back">${icons.back}</button>
                <div class="pg-header__title"><h1>Past talks</h1></div>
            </header>
            <main class="pd-past">
                <div class="pd-past__inner">
                    ${sessions.length ? sessions.map((s) => {
                        const d = window.podium.describeTalk(s);
                        return `<div class="pd-past-item">
                            <button type="button" class="pd-row" data-view="${esc(s.id)}">
                                <span class="pd-row__text"><span class="pd-row__title">${esc(d.title)}</span><span class="pd-row__meta">${esc(window.podium.languageName(s.speakerLanguage))} · ${esc(d.meta)}</span></span>
                            </button>
                            <button type="button" class="pg-iconbtn" data-export="${esc(s.id)}" aria-label="Export ${esc(d.title)}">${icons.download}</button>
                            <button type="button" class="pg-iconbtn" data-delete="${esc(s.id)}" aria-label="Delete ${esc(d.title)}" style="color: var(--pg-danger)">${icons.trash}</button>
                        </div>`;
                    }).join('') : `
                        <div class="pd-state" style="padding-top: 64px">
                            <h2>No talks yet</h2>
                            <p>Talks you give are saved here on this device so you can review or export them later.</p>
                        </div>`}
                </div>
            </main>
        </div>
        <dialog class="pg-dialog" id="session-detail" aria-labelledby="session-detail-title">
            <div class="pg-sheet pd-sheet--wide">
                <div class="pg-sheet__head">
                    <h2 id="session-detail-title">Talk</h2>
                    <button type="button" class="pg-iconbtn" id="close-detail" aria-label="Close">${icons.close}</button>
                </div>
                <div id="session-detail-body"></div>
            </div>
        </dialog>`;

    page.querySelector('#past-back-button').addEventListener('click', () => window.showPage('page-landing'));
    page.querySelectorAll('[data-view]').forEach((b) => b.addEventListener('click', () => viewSession(b.dataset.view)));
    page.querySelectorAll('[data-export]').forEach((b) => b.addEventListener('click', () => exportSession(b.dataset.export)));
    page.querySelectorAll('[data-delete]').forEach((b) => b.addEventListener('click', () => deleteSession(b.dataset.delete)));

    const dialog = page.querySelector('#session-detail');
    page.querySelector('#close-detail').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });

    if (window.podium.openSessionId) {
        const id = window.podium.openSessionId;
        window.podium.openSessionId = null;
        viewSession(id);
    }
}

function viewSession(id) {
    const session = window.podium.getSavedSessions().find((s) => s.id === id);
    if (!session) return;
    const d = window.podium.describeTalk(session);

    const sections = sessionLanguages(session).map((code) => {
        const lines = (session.messages || []).map((m) => m.translations?.[code]).filter((t) => t && t.trim());
        if (!lines.length) return '';
        return `<section><h3>${esc(window.podium.languageName(code))}</h3>${lines.map((t) => `<p>${esc(t)}</p>`).join('')}</section>`;
    }).join('');

    document.getElementById('session-detail-title').textContent = d.title;
    document.getElementById('session-detail-body').innerHTML = `
        <p class="pg-hint" style="margin: 0 0 16px">${esc(d.meta)}</p>
        <div class="pd-transcript">${sections || '<p class="pg-muted">Nothing was transcribed in this talk.</p>'}</div>
        <button type="button" class="pg-btn pg-btn--outline pg-btn--block" id="detail-export" style="margin-top: 20px">${icons.download}<span>Export transcript</span></button>`;
    document.getElementById('detail-export').addEventListener('click', () => exportSession(id));
    document.getElementById('session-detail').showModal();
}

async function exportSession(id) {
    const session = window.podium.getSavedSessions().find((s) => s.id === id);
    if (!session?.messages?.length) return;
    try {
        const zip = new JSZip();
        sessionLanguages(session).forEach((code) => {
            const lines = session.messages.map((m) => m.translations?.[code]).filter((t) => t && t.trim());
            if (lines.length) zip.file(`${window.podium.languageName(code)}.txt`, lines.join('\n\n'));
        });
        const blob = await zip.generateAsync({ type: 'blob' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `podium-talk-${new Date(session.timestamp).toISOString().replace(/[:.]/g, '-').slice(0, -5)}.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Failed to export session:', error);
    }
}

function deleteSession(id) {
    if (!confirm('Delete this talk? This can\'t be undone.')) return;
    const sessions = window.podium.getSavedSessions().filter((s) => s.id !== id);
    localStorage.setItem('podium-sessions', JSON.stringify(sessions));
    initpastsessions();
}

window.initpastsessions = initpastsessions;
